module.exports = __webpack_public_path__ + "static/media/backbttn.4978ba62.png";